import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonDoubleYpsili';
const args = {};

export class OligonDoubleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
